var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-subject-list"},[(_vm.isEmpty)?_c('div',{staticClass:"wx-subject-list__et"},[_vm._v(_vm._s(_vm.emptyTips))]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item,subjectId){return _c('div',{key:subjectId,staticClass:"wx-subject-list__item",on:{"click":function($event){_vm.subjectChange(subjectId)}}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cce56e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aside/SubjectList.vue
// module id = null
// module chunks = 